/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'star': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M24 1c.796 0 1.523.473 1.875 1.22l5.975 12.669 13.361 2.044c.788.12 1.442.698 1.687 1.49a2.26 2.26 0 0 1-.53 2.243L36.7 30.52l2.282 13.922a2.237 2.237 0 0 1-.832 2.14 2.014 2.014 0 0 1-2.202.166L24 40.172l-11.949 6.577a2.014 2.014 0 0 1-2.202-.167 2.237 2.237 0 0 1-.832-2.14L11.3 30.52l-9.667-9.854a2.26 2.26 0 0 1-.53-2.243c.245-.792.9-1.37 1.687-1.49l13.361-2.044 5.975-12.67C22.477 1.474 23.205 1 24 1zm0 7.133l-4.586 9.723a2.1 2.1 0 0 1-1.573 1.197l-10.258 1.57 7.421 7.565c.494.503.719 1.227.602 1.937l-1.75 10.685 9.17-5.048a2.009 2.009 0 0 1 1.947 0l9.172 5.048-1.751-10.685a2.252 2.252 0 0 1 .602-1.937l7.42-7.566-10.257-1.569a2.1 2.1 0 0 1-1.573-1.197L24 8.133z"/>'
  }
})
